/**
 * 2022-01-12
 * 图标文本组件单元
 */

import css from './index.module.scss';
import { EFSelect } from '@/components/UI/svg/ProductStatic';

const defaultData = {
    icon: <EFSelect />,
    title: 'Interior Design',
    des: "DELTA Pro's capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ",
};

const defaultStyle = {
    wrapperWidth: '100%',
    wrapperHeight: 'auto',
    wrapperBackColor: 'transparent',
    wrapperPadding: 0,
    wrapperMargin: '.8rem 0 0 0',
    wrapperBorder: 0,
    wrapperBorderRadius: 0,
    iconMargin: '0 0 .24rem 0',
    iconWidth: '0.48rem',
    iconHeight: '0.48rem',
    iconSize: '.48rem',
    iconColor: '#000',
    titleColor: '#03060b',
    titleFontSize: '0.22rem',
    titleLineHeight: '0.28rem',
    fontWeightTitle: 500,
    desColor: '#222',
    desFontSize: '.14rem',
    desLineHeight: '.22rem',
    fontWeightDesc: 'normal',
    desMargin: '.1rem 0 0 0',
    fontClassTitle: 'font-family-semibold',
    fontClassDes: 'font-family-semibold',
};

/**
 * Style样式参数
 * @param cssStyle {
 *  wrapperWidth： 容器宽 string,
 *  wrapperHeight: 容器高 string,
 *  wrapperBackColor: 容器背景色 string,
 *  wrapperPadding: 容器padding string,
 *  wrapperMargin: 容器margin string,
 *  wrapperBorder: 容器边框 string,
 *  wrapperBorderRadius：容器边框幅度 string,
 *  iconMargin: icon图标margin string,
 *  iconWidth: icon宽 string,
 *  iconHeight: icon高 string,
 *  titleColor: 标题文字颜色 string,
 *  titleFontSize: 标题文字大小 string,
 *  titleLineHeight： 标题文字行高 string,
 *  desColor: 描述文字颜色 string,
 *  desFontSize: 描述文字大小 string,
 *  desLineHeight：描述文字行高 string,
 *  desMargin: 描述文字行的margin string
 * }
 */

/**
 * data 数据参数
 * @param data {
 *  icon：icon路径，
 *  title：标题文本,
 *  des：描述文本,
 * }
 */

export default function TextIconCell({ cssStyle, data }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const dataObj = { ...defaultData, ...data };

    return (
        <div
            className={`${css.textIconCell} textIconCell`}
            style={{
                width: styles.wrapperWidth,
                background: styles.wrapperBackColor,
                padding: styles.wrapperPadding,
                margin: styles.wrapperMargin,
                border: styles.wrapperBorder,
                borderRadius: styles.wrapperBorderRadius,
            }}
        >
            <span
                className="icons signFullImgsBox"
                style={{
                    margin: styles.iconMargin,
                    width: styles.iconWidth,
                    height: styles.iconHeight,
                    fontSize: styles.iconSize,
                    color: styles.iconColor,
                }}
            >
                {dataObj.icon}
            </span>
            <div className="box">
                <p
                    className={`title ${styles.fontClassTitle}`}
                    style={{
                        color: styles.titleColor,
                        fontWeight: styles.fontWeightTitle,
                        fontSize: styles.titleFontSize,
                        lineHeight: styles.titleLineHeight,
                        fontFamily: 'var(--font-family-Bold)',
                    }}
                >
                    {dataObj.title}
                </p>
                <p
                    className={`des ${styles.fontClassDes}`}
                    style={{
                        color: styles.desColor,
                        fontWeight: styles.fontWeightDesc,
                        fontSize: styles.desFontSize,
                        lineHeight: styles.desLineHeight,
                        margin: styles.desMargin,
                    }}
                >
                    {dataObj.des}
                </p>
            </div>
        </div>
    );
}
